import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { MutationConfig } from '@lib/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'
import { getCustomerQueryOptions } from './get-customer'

export const customerCreateFormSchema = z.object({
  email: z.string().min(1, 'Required').email(),
})

export type CustomerCreateFormValues = z.infer<typeof customerCreateFormSchema>

const customerCreateMutationDocument = graphql(`
  mutation customerCreate($input: CustomerRegisterInput!) {
    customerRegister(input: $input) {
      __typename
      errors {
        code: __typename
      }
    }
  }
`)

export const customerCreate = async ({
  data,
}: {
  data: CustomerCreateFormValues
}) => {
  return execute(customerCreateMutationDocument, {
    input: data,
  })
}

type UseCustomerCreateOptions = {
  mutationConfig?: MutationConfig<typeof customerCreate>
}

export const useCustomerCreate = ({
  mutationConfig,
}: UseCustomerCreateOptions = {}) => {
  const queryClient = useQueryClient()

  const { onSuccess, ...restConfig } = mutationConfig || {}

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryOptions().queryKey,
      })
      onSuccess?.(...args)
    },
    ...restConfig,
    mutationFn: customerCreate,
  })
}
